export enum LookerViews {
  ASK_DETAILS_STEP = "ASK_DETAILS_STEP",
  REQUEST_ACCESS_STEP = "REQUEST_ACCESS_STEP",
  FORM_STEP = "FORM_STEP",
  OAUTH_STEP = "OAUTH_STEP",
  CONNECTION_LIST = "CONNECTION_LIST",
}

export const IS_ADMIN_QUESIONS = [
  {
    title: "Yes, I am a Looker admin",
    description: "I have access to the client ID and client secret",
    value: true,
  },
  {
    title: "No, I am not a Looker admin",
    description: "You can still connect",
    value: false,
  },
];

export const HAS_DETAILS_QUESTIONS = [
  {
    title: "Yes, I have them",
    description: "Proceed to enter the client ID and secret in the next step.",
    value: true,
  },
  {
    title: "No, I don’t have them",
    description: `You can still connect by sharing a link with your Looker admin so they can connect on your behalf.`,
    value: false,
  },
];

export const DEFAULT_NOTICE = {
  title: "Don't have client ID & Secret available?",
  subtitle: "Have your admin configure for you",
  step: LookerViews.REQUEST_ACCESS_STEP,
};

export const REQUEST_ADMIN_NOTICE = {
  title: "Already have your client ID & secret?",
  subtitle: "Connect to Looker now",
  step: LookerViews.FORM_STEP,
};

export const OAUTH_NOTICE = {
  title: "Authorize Coefficient to connect to Looker",
};

export const INVALID_CLIENT_ID_ERROR = {
  title: "Could not verify Client ID and Secret",
  message: `Verify the Client ID and Secret are correct and match the ones created in Looker.`,
};

export const CONNECTION_ERROR = {
  title: "Could not connect",
  message: `If your database is behind a firewall or private network you’ll need to whitelist our IP addresses`,
  actionText: "Learn more",
};

// Relative path; consumers prefix with the webappBaseUrl prop.
export const LOOKER_CONFIG_WEBAPP_URL = `/dashboard/settings/manage-looker-oauth`;

export enum AuthType {
  OAUTH = "oauth",
  BASIC = "basic",
}

export const OAUTH_OPTIONS = [
  {
    title: "Enable OAuth",
    description: `Allows other users from your domain to login to Looker using their own username and password, without having to enter a client ID & secret.`,
    isRecommended: true,
    value: AuthType.OAUTH,
    actionName: "Authorize",
  },
  {
    title: "Not right now",
    description: `Users will have to enter a client ID & secret to connect to Looker.`,
    value: AuthType.BASIC,
    actionName: "Complete Setup",
  },
];

export const OAUTH_ACTION_NAMES = {
  [AuthType.OAUTH]: "Authorize",
  [AuthType.BASIC]: "Complete Setup",
} as const;
